import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'quotes',
  children: {
    quoteId: {
      size: 'full',
      path: ':quoteId',
    },
    new: {
      path: 'new',
    },
  },
} as const satisfies Location
